import React from 'react';

export const ServiceCentersFooterText = ({ text }) => {
  return (
    <div className="sc-block sc-footer-text sc-padding">
      <div className="sc-footer-text__description" dangerouslySetInnerHTML={{ __html: text.html }} />
    </div>
  )
};
